/* eslint-disable eqeqeq */
import React,{useState,useCallback,useEffect} from 'react';
import {findDOMNode} from 'react-dom';
import {ListView,InputItem,Button,Flex} from 'antd-mobile';
import {connect} from 'dva';
const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
/********************************************************** */
let lv;
let lvTemp=0;
let AAE001= 0;
let scorllTop=0;
let rData=[];
let hasMore = true;
/***************************************************** */
function initLet()
{
  AAE001= 0;
  rData=[];
  hasMore = true;
}

let renderHeader =()=>{
    return (<span>制单人</span>);
}

 

//间距
function renderSeparator(sectionID,rowID){
    return (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 2,
          borderTop: '1px solid #ECECED',
          borderBottom: '1px solid #ECECED',
        }}
      />
    );
  }
  function onScroll(scroll){
    
    lvTemp=scroll.target.scrollTop;
    console.log(lvTemp);
     
  }

  //制单人
function OrderingPerson (props)
{
    let [LVdataSource,setDataSource] = useState(dataSource);
    let [AAE004,setAAE004] =useState();
    let [height,setHeight] = useState(document.documentElement.clientHeight);

    
    
    useEffect(()=>{

       if (AAE001==0)
       {
        initLet();
        genData();
        setHeight(height - findDOMNode(lv).offsetTop);
        
       }else{
        setDataSource(dataSource.cloneWithRows(rData));
        setTimeout(() => lv.scrollTo(0, scorllTop), 800);
        
       }
       return ()=>{
        scorllTop=lvTemp;
       }
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[0]);

    
    let genData = useCallback(()=>{
        props.dispatch({type:"order/ae01GetZdr",payload:{
          AAA001:localStorage.getItem("AAA001"),
          AAE001,
          AAE004
      }}).then((res)=>{

          if(res.length>0)
          {
              hasMore = true;
          }else{
              hasMore = false;
          }
          rData.push(...res);
          setDataSource(dataSource.cloneWithRows(rData));
          AAE001 = AAE001+10
      });
    },[props,AAE004]);


    let onEndReached = useCallback(()=>{
        if (props.isLoading ) {
          return;
        }
        if(!hasMore)
        {
            return;
        }
          genData();

      },[props.isLoading,genData]);

      let renderFooter = useCallback(()=>{
        return (
          <div style={{ padding: 30, textAlign: 'center' }}>{ hasMore?(props.isLoading ? '请稍等正在加载...' : '加载完成'):'亲掉头吧...没有数据了'}</div>
        );
       },[props.isLoading]);

     let handelSearch = useCallback(()=>{
         initLet();
         genData();
     },[genData]);


    let allHandle =(rowData)=>{
        props.dispatch({type:"order/routerZdrOrder",payload:{
         AAE002 : rowData.AAE002,
         AAE004 : rowData.AAE004,
         route:"/zdrOrder"
        }});
 
      }
      let wjsHandle =(rowData)=>{
       props.dispatch({type:"order/routerZdrOrder",payload:{
        AAE002 : rowData.AAE002,
        AAE004 : rowData.AAE004,
        route:"/zdrWjsOrder"
       }});
 
     }
 
     let ytjHandle =(rowData)=>{
       props.dispatch({type:"echart/toZdrCusMomthTj",payload:{
        AAE002 : rowData.AAE002,
        AAE004 : rowData.AAE004,
        route:"/zdrCusMonthTj"
       }});
 
     }
         //行显示
  let renderRow=(rowData, sectionID, rowID)=>
  {
    let spancss;
    if (rowData.AAA001 == localStorage.getItem("AAA001"))
    {
      spancss = {fontSize: '15px', color: '#ff0900'};
    }else{
      spancss = {fontSize: '15px', color: '#000000'};
    }
    return (
      <div key={rowID} style={{ padding: '0 15px' }}>
        <div style={{lineHeight: '30px',color: '#888',fontSize: 15,borderBottom: '1px solid #0051ff',}}>
        <span style={spancss}> { `制单人: ${rowData.AAE004}` } </span>
        </div>

          <Button type="primary" onClick={()=>wjsHandle(rowData)} inline size="small" style={{ marginRight: '1px' }}>未结算送货单</Button>
          <Button type="warning" onClick={()=>allHandle(rowData)} inline size="small" style={{ marginRight: '1px' }}>全部送货单</Button>
          <Button type="warning" onClick={()=>ytjHandle(rowData)} inline size="small" style={{ marginRight: '1px' }}>月统计</Button>
      </div>
    );
  }
    return (<div>
        <Flex className="gridHead" alignContent ="between">
          <InputItem type="text" value={AAE004} onChange={(value)=>setAAE004(value)} placeholder="请输入制单人..." ></InputItem>
          <Button type="primary" inline onClick={handelSearch}  >搜索</Button>
        </Flex >
        
        <ListView
          key={0}
          ref={el => lv = el}
          onScroll={onScroll}
          dataSource={LVdataSource}
          renderHeader={renderHeader}
          renderFooter={renderFooter}
          renderRow={renderRow}
          renderSeparator={renderSeparator}
          useBodyScroll={false}
          style={ {height: height,border: '1px solid #ddd',margin: '5px 0',}}
          onEndReached={onEndReached}
          pageSize={5}
        />
      </div>);
}

export default connect(state=>{
    return {
        ...state.order,
        isLoading: state.loading.global
    }
}) (OrderingPerson);